export default "__VITE_ASSET__0b89601e__"